import { Button, type ButtonProps } from 'antd';
import type React from 'react';
import { useCallback, useState } from 'react';

export interface IAsyncButtonProps extends ButtonProps {
  onClick: (e: React.MouseEvent<HTMLElement>) => Promise<void>;
}

/**
 * Bottone che gestisce in maniera automatica gli onClick asincroni
 */
export function AsyncButton(props: IAsyncButtonProps) {
  const { onClick, ...otherProps } = props;

  const [loading, setLoading] = useState(false);

  const handleClick = useCallback(
    (e: React.MouseEvent<HTMLElement>) => {
      const fn = async () => {
        setLoading(true);
        await onClick(e);
        setLoading(false);
      };
      fn();
    },
    [onClick],
  );

  return (
    <Button
      {...otherProps}
      loading={props.loading || loading}
      onClick={handleClick}
    />
  );
}
